// extracted by mini-css-extract-plugin
module.exports = {"DialogContent":"default_DialogContent__mVD6E","contentShow":"default_contentShow__3NWYP","DialogClose":"default_DialogClose__HxMbm"};